
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.33703',
  depVersions: {
  "documents-public-ui": "static-1.33703",
  "client-types": "static-1.441",
  "documents-lib": "static-1.33708",
  "emoji-mart": "static-3.4",
  "foundations-theming-specialty": "static-1.1803",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.4702",
  "highcharts": "static-8.97",
  "hs-promise-utils": "static-1.5278",
  "hs-test-utils": "static-1.7667",
  "hub-http": "static-1.5872",
  "hubspot-dlb": "static-2.1773",
  "HubStyleTokens": "static-2.11108",
  "I18n": "static-7.1538",
  "jasmine-immutable": "static-1.2704",
  "jasmine-runner": "static-1.6138",
  "lodash": "static-1.3",
  "quartz": "static-1.6566",
  "react": "static-7.175",
  "react-dlb": "static-1.69",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-redux": "static-7.65",
  "react-rhumb": "static-1.16318",
  "reporting-data": "static-1.66016",
  "reporting-testing-lib": "static-1.7950",
  "reporting-visualizations": "static-1.58093",
  "tinymce": "static-6.5",
  "ui-addon-draggable": "static-3.4431",
  "webpack-env": "static-1.54",
  "atom": "static-1.4759",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2150",
  "classnames": "static-2.10",
  "crm_schema": "static-3.90915",
  "cssUtils": "static-1.694",
  "customer-data-filters-ui": "static-1.38485",
  "customer-data-objects": "static-1.7298",
  "customer-data-property-utils": "static-1.7755",
  "data-fetching-client": "static-1.9360",
  "enviro": "static-4.371",
  "FireAlarmUi": "static-1.4221",
  "flux-actions": "static-1.295",
  "FormsCommonComponents": "static-1.84957",
  "FormUrlGenerator": "static-2.4418",
  "foundations-components": "static-1.7278",
  "history": "static-4.47",
  "hs-lodash": "static-4.45",
  "hubspot-url-utils": "static-1.3825",
  "HubStyle": "static-2.11416",
  "icons": "static-2.611",
  "immutable": "static-2.19",
  "isMobile": "static-1.7",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.6830",
  "metrics-js": "static-1.9296",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "PortalIdParser": "static-2.334",
  "property-description-translator": "static-1.3545",
  "property-translator": "static-1.5099",
  "quartz-config": "static-1.344",
  "quartz-core": "static-1.5785",
  "quick-fetch": "static-1.3623",
  "raven": "static-3.5564",
  "react-dom": "static-7.85",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-router-dom": "static-5.26",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5071",
  "react-virtualized": "static-2.92",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.7845",
  "reference-resolvers-lite": "static-1.7778",
  "report-customization-components": "static-1.12202",
  "reporting-enablement": "static-1.21701",
  "reporting-reports": "static-1.65695",
  "reporting-snowflake": "static-1.54635",
  "reporting-ui-components": "static-2.63289",
  "reselect": "static-2.16",
  "rpc-client-utils": "static-1.4290",
  "sales-content-partitioning": "static-1.8620",
  "SalesContentIndexUI": "static-3.8729",
  "sanitize": "static-1.4161",
  "sanitize-text": "static-1.7828",
  "self-service-api": "static-1.9911",
  "SharedI18nStrings": "static-1.179",
  "SharedLegalStrings": "static-1.1454",
  "signup-constants": "static-1.18183",
  "signup-ui-lego-core": "static-1.20193",
  "signup-ui-url-generator": "static-2.7717",
  "styled-components": "static-2.83",
  "StyleGuideUI": "static-3.481",
  "superstore": "static-1.4459",
  "transmute": "static-2.77",
  "ui-addon-form-validation": "static-1.10683",
  "ui-addon-i18n": "static-1.10812",
  "ui-addon-react-router-dom": "static-1.9234",
  "ui-addon-upgrades": "static-9.17400",
  "ui-asset-management-lib": "static-1.10543",
  "ui-images": "static-2.1056",
  "UIComponents": "static-3.8055",
  "usage-tracker": "static-1.7023",
  "usage-tracker-container": "static-1.7013",
  "usage-tracker-core": "static-1.6873",
  "usage-tracker-public": "static-1.6834",
  "viral-links-lib": "static-1.6707",
  "hs-promise-rejection-tracking": "static-1.5234",
  "raven-hubspot": "static-1.5871",
  "hoist-non-react-statics": "static-3.9",
  "bend-plugin-trellis-migration": "static-1.3121",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.2843",
  "quartz-webpack": "static-1.2790",
  "ai-components-ui-library": "static-1.8061",
  "amplitude-session-replay-browser": "static-1.53",
  "foundations-assets": "static-1.4516",
  "foundations-theming": "static-1.4087",
  "react-transition-group": "static-1.7",
  "usage-tracker-session-replay": "static-1.4709",
  "foundations-theming-base": "static-1.3072",
  "HeadJS": "static-2.687",
  "framer-motion": "static-1.64",
  "hs-test-utils-bend-plugin": "static-1.2778",
  "msw": "static-1.39",
  "testing-library": "static-1.145",
  "i18n-data": "static-1.214",
  "moment-timezone": "static-5.76",
  "jasmine": "static-4.4017",
  "csstype": "static-1.50",
  "frontend-preferences-client": "static-1.7610",
  "graphql": "static-1.75",
  "immer": "static-1.33",
  "inbound-db-meta-service-client": "static-1.3355",
  "persist-promise": "static-1.3373",
  "reporting-client-types": "static-1.2354",
  "hs-story-utils": "static-1.9115",
  "react-flip-move": "static-1.63",
  "hub-http-shared-msw-handlers": "static-1.9187",
  "hubspotter-http": "static-1.4374",
  "sassPrefix": "static-1.149",
  "conversations-skeleton-state": "static-1.6938",
  "crm-message-bus": "static-1.42060",
  "customer-data-filters-ui-msw-helpers": "static-1.20919",
  "customer-data-objects-ui-components": "static-1.12689",
  "customer-data-reference-ui-components": "static-1.12824",
  "customer-data-ui-utilities": "static-1.9512",
  "framework-builder-read-service-client": "static-1.3743",
  "framework-data-schema-quick-fetch": "static-1.6457",
  "framework-data-schema-resolvers": "static-1.6552",
  "inbound-db-properties-service-client": "static-1.3574",
  "multi-account-reference-resolvers": "static-1.652",
  "onboarding-tours": "static-1.16116",
  "reporting-datasets-permissions-lib": "static-1.12668",
  "ui-addon-teams": "static-1.21075",
  "apollo-stack-hubspot": "static-3.79",
  "fast-json-stable-stringify": "static-1.4",
  "ContentUtils": "static-1.67260",
  "customer-data-properties": "static-1.50455",
  "forms-ai-lib": "static-1.3817",
  "forms-utils-lib": "static-1.11960",
  "foundations-components-test-utils": "static-1.4761",
  "react-dnd-compat": "static-1.4310",
  "react-tinymce": "static-1.54322",
  "tinymce-config": "static-2.53448",
  "ui-gdpr-components": "static-1.10032",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.3547",
  "floating-ui": "static-1.49",
  "react-aria": "static-1.59",
  "tanstack-table": "static-1.48",
  "trellis-assets": "static-1.959",
  "ui-fonts": "static-1.370",
  "dispatcher": "static-1.129",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.767",
  "mobile-manifest-mixins": "static-1.460",
  "quartz-auth": "static-1.241",
  "quartz-head": "static-1.231",
  "quartz-i18n": "static-1.241",
  "quartz-test": "static-1.241",
  "batch-promise": "static-1.1216",
  "external-options-client-types": "static-1.3877",
  "react-colorpicker": "static-2.9900",
  "reporting-insights-lib": "static-1.849",
  "copilot-toolkit": "static-1.10251",
  "data-quality-ui-library": "static-1.12071",
  "html-to-image": "static-1.47",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.40401",
  "reporting-plugins": "static-1.9840",
  "ui-addon-draggable-compat": "static-2.3941",
  "ui-addon-opt": "static-4.8075",
  "ui-shepherd-react": "static-3.9829",
  "zustand": "static-1.51",
  "growth-payments-core": "static-1.24411",
  "hubspot-apollo-client": "static-1.4567",
  "sales-templates-service-types-lib": "static-1.3889",
  "ui-business-units-lib": "static-1.8706",
  "merchandise-lib": "static-1.253",
  "emoji-regex": "static-1.7",
  "feature-store-service-types": "static-1.4213",
  "purchase-motions-components": "static-1.5316",
  "salesImages": "static-1.518",
  "ts-schema": "static-1.3800",
  "upgrade-management-service-types": "static-1.4204",
  "timezone-utils": "static-2.4931",
  "bender-build-tools": "static-1.2798",
  "chatspot-core": "static-1.19885",
  "bend-plugin-foundations-theming": "static-1.2570",
  "stylex": "static-1.25",
  "react-immutable-render-mixin": "static-1.9",
  "conditional-properties-service-client": "static-1.3517",
  "crm-pipelines-api-client-types": "static-1.3860",
  "multi-currency-client-types": "static-1.3417",
  "getting-started-shared-tasks": "static-1.17560",
  "growth-data-modal": "static-1.5018",
  "growth-onboarding-confetti": "static-1.2737",
  "growth-onboarding-next-action-utils": "static-1.1182",
  "navigation-components": "static-1.16946",
  "onboarding-tours-client": "static-1.4330",
  "onboarding-tours-utils": "static-1.182",
  "ui-shepherd-tracker": "static-1.7210",
  "ui-universal-auth": "static-1.8542",
  "user-context": "static-1.4781",
  "cms-field-types": "static-1.4494",
  "content-icons-ui": "static-1.2111",
  "integrations-lib": "static-1.15055",
  "calling-global-api": "static-1.63266",
  "calling-internal-common": "static-1.30975",
  "calling-lifecycle-internal": "static-1.64648",
  "calling-lifecycle-messages": "static-1.56942",
  "commerce-products-lib": "static-1.8511",
  "crm-links": "static-1.5939",
  "file-manager-components": "static-1.22565",
  "google-libphonenumber": "static-1.31",
  "hs-entities": "static-1.337",
  "inbounddb-objects-service-types": "static-1.3945",
  "meetings-icalendar-utils-lib": "static-1.320",
  "object-builder-ui-client": "static-1.47615",
  "pipeline-validation-client-types": "static-1.3680",
  "property-value-citations": "static-1.1069",
  "pulse": "static-1.172",
  "smart-property-lib": "static-1.5483",
  "tiered-pricing": "static-1.649",
  "ui-addon-iframeable": "static-1.8703",
  "final-form": "static-1.63",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.19271",
  "tinymce-themes": "static-1.55418",
  "data-token-picker": "static-1.15870",
  "hub-http-contrib": "static-1.2735",
  "interframe": "static-3.4479",
  "tinymce-data": "static-1.39533",
  "tinymce-plugins": "static-1.56562",
  "ui-addon-sales-email": "static-1.4901",
  "hubspotter-http-shared-msw-handlers": "static-1.9185",
  "magpie-lib": "static-1.5262",
  "magpie-types": "static-1.4722",
  "simple-logging-lib": "static-1.2738",
  "content-assistance-lib": "static-1.7287",
  "dashboard-lib": "static-1.80173",
  "ExportDialog": "static-6.10075",
  "hubspot-prosemirror": "static-1.17305",
  "hubspot-prosemirror-plugins": "static-1.17297",
  "prosemirror": "static-1.13",
  "share-with-third-party-component-lib": "static-1.8373",
  "campaign-roi-lib": "static-1.7938",
  "feedback-loader": "static-1.28658",
  "commerce-analytics-service-client": "static-1.3375",
  "onboarding-scopes": "static-1.6130",
  "apollo-link-hub-http": "static-2.4335",
  "hubspot-apollo-cache": "static-1.26",
  "growth-monetization-service-types": "static-1.4220",
  "nav-client-types": "static-1.2018",
  "purchase-motions-api": "static-1.5319",
  "trials-service-types": "static-1.3621",
  "chatspot-client-types": "static-1.10328",
  "idb-keyval": "static-1.37",
  "reactive-lib": "static-1.413",
  "getting-started-shared-tasks-store": "static-1.16678",
  "integrations-error-boundary-lib": "static-1.12470",
  "integrations-tracking-lib": "static-1.5271",
  "native-integrations-shared-strings": "static-1.7474",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10061",
  "rxjs": "static-5.10",
  "calling-error-reporting": "static-1.30981",
  "shared-worker-versioning": "static-1.10704",
  "calling-usage-tracker": "static-1.6226",
  "calling-orchestration-shared-library": "static-1.34462",
  "customer-data-tracking": "static-1.6548",
  "products-iframe-lib": "static-1.7049",
  "products-ui-components-shared-msw-handlers": "static-1.9569",
  "location-customization-utils-lib": "static-1.8202",
  "apollo-dlb": "static-3.80",
  "immerable": "static-1.3843",
  "video-components-external": "static-1.10226",
  "video-data-lib": "static-1.33884",
  "directed-graph": "static-1.624",
  "event-emitter": "static-1.612",
  "breeze-intelligence-kit": "static-1.5152",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9270",
  "fsm": "static-1.3418",
  "policy-lib": "static-1.6489",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9333",
  "navigation-messaging": "static-1.6273",
  "FileManagerLib": "static-1.38205",
  "NamespacedHubStyle": "static-2.8797",
  "FileManagerCore": "static-1.38064",
  "codemirror": "static-5.88",
  "layout-dnd-components": "static-1.11838",
  "layout-dnd-utils": "static-1.10813",
  "react-codemirror": "static-1.10289",
  "ui-addon-emoji-picker": "static-1.9577",
  "ui-brand-identity-lib": "static-1.13394",
  "ui-addon-video-player": "static-1.8408",
  "ui-coaching-tips": "static-1.27636",
  "redux-actions": "static-3.7",
  "knowledge-content-types": "static-1.8266",
  "payment-link-components": "static-1.22623",
  "EmailSignatureEditor": "static-1.23724",
  "eligibility-engine-service-types": "static-1.2902",
  "universal-page-editor-lib": "static-1.2683",
  "calling-orchestration-schema": "static-1.34687",
  "sales-views-client-types": "static-1.3980",
  "crm-record-cards-service-types": "static-1.3348",
  "content-media-composition-data-lib": "static-1.10973",
  "content-media-compositions": "static-2.14980",
  "media-bridge-lib": "static-1.18388",
  "trellis-story-utils": "static-1.4210",
  "storybook-react": "static-1.26",
  "audio-components": "static-1.5450",
  "FileManagerImages": "static-1.35716",
  "video-components": "static-1.12229",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4220",
  "video-embed": "static-1.34718",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.67335",
  "layout-data-lib": "static-1.9138",
  "browser-eslint": "static-2.57",
  "growth-onboarding-feedback-components": "static-1.6273",
  "commerce-tours-lib": "static-1.5546",
  "growth-onboarding-reliability": "static-1.4775",
  "sales-checkout-service-client": "static-1.3387",
  "draft-convert": "static-2.31",
  "draft-extend": "static-2.46",
  "draft-js": "static-5.37",
  "draft-plugins": "static-2.21111",
  "sales-email-signature-service-client": "static-1.3527",
  "hls.js": "static-1.32",
  "social-insights-client-types": "static-1.21075",
  "outpost": "static-1.3901",
  "advanced-menus-core": "static-1.14636",
  "advanced-menus-lib": "static-1.11628",
  "ui-memberships-settings-lib": "static-1.33124",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14635",
  "simple-menus-lib": "static-1.16152"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.33703",
  "client-types": "/client-types/static-1.441",
  "documents-lib": "/documents-lib/static-1.33708",
  "emoji-mart": "/emoji-mart/static-3.4",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1803",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.4702",
  "highcharts": "/highcharts/static-8.97",
  "hs-promise-utils": "/hs-promise-utils/static-1.5278",
  "hs-test-utils": "/hs-test-utils/static-1.7667",
  "hub-http": "/hub-http/static-1.5872",
  "hubspot-dlb": "/hubspot-dlb/static-2.1773",
  "HubStyleTokens": "/HubStyleTokens/static-2.11108",
  "I18n": "/I18n/static-7.1538",
  "jasmine-immutable": "/jasmine-immutable/static-1.2704",
  "jasmine-runner": "/jasmine-runner/static-1.6138",
  "lodash": "/lodash/static-1.3",
  "quartz": "/quartz/static-1.6566",
  "react": "/react/static-7.175",
  "react-dlb": "/react-dlb/static-1.69",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-redux": "/react-redux/static-7.65",
  "react-rhumb": "/react-rhumb/static-1.16318",
  "reporting-data": "/reporting-data/static-1.66016",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.7950",
  "reporting-visualizations": "/reporting-visualizations/static-1.58093",
  "tinymce": "/tinymce/static-6.5",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4431",
  "webpack-env": "/webpack-env/static-1.54",
  "atom": "/atom/static-1.4759",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2150",
  "classnames": "/classnames/static-2.10",
  "crm_schema": "/crm_schema/static-3.90915",
  "cssUtils": "/cssUtils/static-1.694",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.38485",
  "customer-data-objects": "/customer-data-objects/static-1.7298",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7755",
  "data-fetching-client": "/data-fetching-client/static-1.9360",
  "enviro": "/enviro/static-4.371",
  "FireAlarmUi": "/FireAlarmUi/static-1.4221",
  "flux-actions": "/flux-actions/static-1.295",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.84957",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4418",
  "foundations-components": "/foundations-components/static-1.7278",
  "history": "/history/static-4.47",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3825",
  "HubStyle": "/HubStyle/static-2.11416",
  "icons": "/icons/static-2.611",
  "immutable": "/immutable/static-2.19",
  "isMobile": "/isMobile/static-1.7",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.6830",
  "metrics-js": "/metrics-js/static-1.9296",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "PortalIdParser": "/PortalIdParser/static-2.334",
  "property-description-translator": "/property-description-translator/static-1.3545",
  "property-translator": "/property-translator/static-1.5099",
  "quartz-config": "/quartz-config/static-1.344",
  "quartz-core": "/quartz-core/static-1.5785",
  "quick-fetch": "/quick-fetch/static-1.3623",
  "raven": "/raven/static-3.5564",
  "react-dom": "/react-dom/static-7.85",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-router-dom": "/react-router-dom/static-5.26",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5071",
  "react-virtualized": "/react-virtualized/static-2.92",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.7845",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7778",
  "report-customization-components": "/report-customization-components/static-1.12202",
  "reporting-enablement": "/reporting-enablement/static-1.21701",
  "reporting-reports": "/reporting-reports/static-1.65695",
  "reporting-snowflake": "/reporting-snowflake/static-1.54635",
  "reporting-ui-components": "/reporting-ui-components/static-2.63289",
  "reselect": "/reselect/static-2.16",
  "rpc-client-utils": "/rpc-client-utils/static-1.4290",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.8620",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8729",
  "sanitize": "/sanitize/static-1.4161",
  "sanitize-text": "/sanitize-text/static-1.7828",
  "self-service-api": "/self-service-api/static-1.9911",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.179",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1454",
  "signup-constants": "/signup-constants/static-1.18183",
  "signup-ui-lego-core": "/signup-ui-lego-core/static-1.20193",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7717",
  "styled-components": "/styled-components/static-2.83",
  "StyleGuideUI": "/StyleGuideUI/static-3.481",
  "superstore": "/superstore/static-1.4459",
  "transmute": "/transmute/static-2.77",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10683",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10812",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9234",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17400",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10543",
  "ui-images": "/ui-images/static-2.1056",
  "UIComponents": "/UIComponents/static-3.8055",
  "usage-tracker": "/usage-tracker/static-1.7023",
  "usage-tracker-container": "/usage-tracker-container/static-1.7013",
  "usage-tracker-core": "/usage-tracker-core/static-1.6873",
  "usage-tracker-public": "/usage-tracker-public/static-1.6834",
  "viral-links-lib": "/viral-links-lib/static-1.6707",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5234",
  "raven-hubspot": "/raven-hubspot/static-1.5871",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3121",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.2843",
  "quartz-webpack": "/quartz-webpack/static-1.2790",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8061",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.53",
  "foundations-assets": "/foundations-assets/static-1.4516",
  "foundations-theming": "/foundations-theming/static-1.4087",
  "react-transition-group": "/react-transition-group/static-1.7",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4709",
  "foundations-theming-base": "/foundations-theming-base/static-1.3072",
  "HeadJS": "/HeadJS/static-2.687",
  "framer-motion": "/framer-motion/static-1.64",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2778",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.145",
  "i18n-data": "/i18n-data/static-1.214",
  "moment-timezone": "/moment-timezone/static-5.76",
  "jasmine": "/jasmine/static-4.4017",
  "csstype": "/csstype/static-1.50",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7610",
  "graphql": "/graphql/static-1.75",
  "immer": "/immer/static-1.33",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3355",
  "persist-promise": "/persist-promise/static-1.3373",
  "reporting-client-types": "/reporting-client-types/static-1.2354",
  "hs-story-utils": "/hs-story-utils/static-1.9115",
  "react-flip-move": "/react-flip-move/static-1.63",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9187",
  "hubspotter-http": "/hubspotter-http/static-1.4374",
  "sassPrefix": "/sassPrefix/static-1.149",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.6938",
  "crm-message-bus": "/crm-message-bus/static-1.42060",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.20919",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12689",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12824",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9512",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3743",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6457",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6552",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3574",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.652",
  "onboarding-tours": "/onboarding-tours/static-1.16116",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.12668",
  "ui-addon-teams": "/ui-addon-teams/static-1.21075",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.79",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "ContentUtils": "/ContentUtils/static-1.67260",
  "customer-data-properties": "/customer-data-properties/static-1.50455",
  "forms-ai-lib": "/forms-ai-lib/static-1.3817",
  "forms-utils-lib": "/forms-utils-lib/static-1.11960",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.4761",
  "react-dnd-compat": "/react-dnd-compat/static-1.4310",
  "react-tinymce": "/react-tinymce/static-1.54322",
  "tinymce-config": "/tinymce-config/static-2.53448",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10032",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3547",
  "floating-ui": "/floating-ui/static-1.49",
  "react-aria": "/react-aria/static-1.59",
  "tanstack-table": "/tanstack-table/static-1.48",
  "trellis-assets": "/trellis-assets/static-1.959",
  "ui-fonts": "/ui-fonts/static-1.370",
  "dispatcher": "/dispatcher/static-1.129",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.767",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.460",
  "quartz-auth": "/quartz-auth/static-1.241",
  "quartz-head": "/quartz-head/static-1.231",
  "quartz-i18n": "/quartz-i18n/static-1.241",
  "quartz-test": "/quartz-test/static-1.241",
  "batch-promise": "/batch-promise/static-1.1216",
  "external-options-client-types": "/external-options-client-types/static-1.3877",
  "react-colorpicker": "/react-colorpicker/static-2.9900",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.849",
  "copilot-toolkit": "/copilot-toolkit/static-1.10251",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12071",
  "html-to-image": "/html-to-image/static-1.47",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.40401",
  "reporting-plugins": "/reporting-plugins/static-1.9840",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.3941",
  "ui-addon-opt": "/ui-addon-opt/static-4.8075",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.9829",
  "zustand": "/zustand/static-1.51",
  "growth-payments-core": "/growth-payments-core/static-1.24411",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4567",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.3889",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8706",
  "merchandise-lib": "/merchandise-lib/static-1.253",
  "emoji-regex": "/emoji-regex/static-1.7",
  "feature-store-service-types": "/feature-store-service-types/static-1.4213",
  "purchase-motions-components": "/purchase-motions-components/static-1.5316",
  "salesImages": "/salesImages/static-1.518",
  "ts-schema": "/ts-schema/static-1.3800",
  "upgrade-management-service-types": "/upgrade-management-service-types/static-1.4204",
  "timezone-utils": "/timezone-utils/static-2.4931",
  "bender-build-tools": "/bender-build-tools/static-1.2798",
  "chatspot-core": "/chatspot-core/static-1.19885",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2570",
  "stylex": "/stylex/static-1.25",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3517",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3860",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3417",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17560",
  "growth-data-modal": "/growth-data-modal/static-1.5018",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2737",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1182",
  "navigation-components": "/navigation-components/static-1.16946",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4330",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.182",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7210",
  "ui-universal-auth": "/ui-universal-auth/static-1.8542",
  "user-context": "/user-context/static-1.4781",
  "cms-field-types": "/cms-field-types/static-1.4494",
  "content-icons-ui": "/content-icons-ui/static-1.2111",
  "integrations-lib": "/integrations-lib/static-1.15055",
  "calling-global-api": "/calling-global-api/static-1.63266",
  "calling-internal-common": "/calling-internal-common/static-1.30975",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.64648",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.56942",
  "commerce-products-lib": "/commerce-products-lib/static-1.8511",
  "crm-links": "/crm-links/static-1.5939",
  "file-manager-components": "/file-manager-components/static-1.22565",
  "google-libphonenumber": "/google-libphonenumber/static-1.31",
  "hs-entities": "/hs-entities/static-1.337",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.3945",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.320",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.47615",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3680",
  "property-value-citations": "/property-value-citations/static-1.1069",
  "pulse": "/pulse/static-1.172",
  "smart-property-lib": "/smart-property-lib/static-1.5483",
  "tiered-pricing": "/tiered-pricing/static-1.649",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8703",
  "final-form": "/final-form/static-1.63",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.19271",
  "tinymce-themes": "/tinymce-themes/static-1.55418",
  "data-token-picker": "/data-token-picker/static-1.15870",
  "hub-http-contrib": "/hub-http-contrib/static-1.2735",
  "interframe": "/interframe/static-3.4479",
  "tinymce-data": "/tinymce-data/static-1.39533",
  "tinymce-plugins": "/tinymce-plugins/static-1.56562",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.4901",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9185",
  "magpie-lib": "/magpie-lib/static-1.5262",
  "magpie-types": "/magpie-types/static-1.4722",
  "simple-logging-lib": "/simple-logging-lib/static-1.2738",
  "content-assistance-lib": "/content-assistance-lib/static-1.7287",
  "dashboard-lib": "/dashboard-lib/static-1.80173",
  "ExportDialog": "/ExportDialog/static-6.10075",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17305",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17297",
  "prosemirror": "/prosemirror/static-1.13",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8373",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.7938",
  "feedback-loader": "/feedback-loader/static-1.28658",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3375",
  "onboarding-scopes": "/onboarding-scopes/static-1.6130",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4335",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.26",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4220",
  "nav-client-types": "/nav-client-types/static-1.2018",
  "purchase-motions-api": "/purchase-motions-api/static-1.5319",
  "trials-service-types": "/trials-service-types/static-1.3621",
  "chatspot-client-types": "/chatspot-client-types/static-1.10328",
  "idb-keyval": "/idb-keyval/static-1.37",
  "reactive-lib": "/reactive-lib/static-1.413",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.16678",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12470",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5271",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7474",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10061",
  "rxjs": "/rxjs/static-5.10",
  "calling-error-reporting": "/calling-error-reporting/static-1.30981",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10704",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6226",
  "calling-orchestration-shared-library": "/calling-orchestration-shared-library/static-1.34462",
  "customer-data-tracking": "/customer-data-tracking/static-1.6548",
  "products-iframe-lib": "/products-iframe-lib/static-1.7049",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9569",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8202",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "immerable": "/immerable/static-1.3843",
  "video-components-external": "/video-components-external/static-1.10226",
  "video-data-lib": "/video-data-lib/static-1.33884",
  "directed-graph": "/directed-graph/static-1.624",
  "event-emitter": "/event-emitter/static-1.612",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5152",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9270",
  "fsm": "/fsm/static-1.3418",
  "policy-lib": "/policy-lib/static-1.6489",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9333",
  "navigation-messaging": "/navigation-messaging/static-1.6273",
  "FileManagerLib": "/FileManagerLib/static-1.38205",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8797",
  "FileManagerCore": "/FileManagerCore/static-1.38064",
  "codemirror": "/codemirror/static-5.88",
  "layout-dnd-components": "/layout-dnd-components/static-1.11838",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.10813",
  "react-codemirror": "/react-codemirror/static-1.10289",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9577",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.13394",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8408",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.27636",
  "redux-actions": "/redux-actions/static-3.7",
  "knowledge-content-types": "/knowledge-content-types/static-1.8266",
  "payment-link-components": "/payment-link-components/static-1.22623",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.23724",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.2902",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2683",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.34687",
  "sales-views-client-types": "/sales-views-client-types/static-1.3980",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3348",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.10973",
  "content-media-compositions": "/content-media-compositions/static-2.14980",
  "media-bridge-lib": "/media-bridge-lib/static-1.18388",
  "trellis-story-utils": "/trellis-story-utils/static-1.4210",
  "storybook-react": "/storybook-react/static-1.26",
  "audio-components": "/audio-components/static-1.5450",
  "FileManagerImages": "/FileManagerImages/static-1.35716",
  "video-components": "/video-components/static-1.12229",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4220",
  "video-embed": "/video-embed/static-1.34718",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.67335",
  "layout-data-lib": "/layout-data-lib/static-1.9138",
  "browser-eslint": "/browser-eslint/static-2.57",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6273",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5546",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4775",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3387",
  "draft-convert": "/draft-convert/static-2.31",
  "draft-extend": "/draft-extend/static-2.46",
  "draft-js": "/draft-js/static-5.37",
  "draft-plugins": "/draft-plugins/static-2.21111",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3527",
  "hls.js": "/hls.js/static-1.32",
  "social-insights-client-types": "/social-insights-client-types/static-1.21075",
  "outpost": "/outpost/static-1.3901",
  "advanced-menus-core": "/advanced-menus-core/static-1.14636",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11628",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33124",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14635",
  "simple-menus-lib": "/simple-menus-lib/static-1.16152"
}
};
